exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-search__close[data-v-044e3706] {\n  color: transparent;\n}\n.form-search__btn[data-v-044e3706] {\n  display: inline-flex;\n  align-items: center;\n}\n.form-search__btn.loading[data-v-044e3706] {\n  background: #fff;\n}\n.form-search[data-v-044e3706] {\n  position: relative;\n}\n.navbar.search-open .search-result.active[data-v-044e3706] {\n  opacity: 1;\n}\n.navbar .search-result[data-v-044e3706] {\n  padding: 1rem;\n  opacity: 0;\n  overflow: scroll;\n  max-height: 600px;\n  transition: all 0.2s ease-in-out;\n  position: absolute;\n  top: 104%;\n  left: 0;\n  right: 0;\n  background-color: #fff;\n}", ""]);

// exports
